var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.2C9.55819 9.2 9.20002 9.55817 9.20002 10C9.20002 10.4418 9.55819 10.8 10 10.8C10.4418 10.8 10.8 10.4418 10.8 10C10.8 9.55817 10.4418 9.2 10 9.2ZM8.00002 10C8.00002 8.89543 8.89545 8 10 8C11.1046 8 12 8.89543 12 10C12 11.1046 11.1046 12 10 12C8.89545 12 8.00002 11.1046 8.00002 10ZM16.5 9.20001C16.0582 9.20001 15.7 9.55818 15.7 10C15.7 10.4418 16.0582 10.8 16.5 10.8C16.9418 10.8 17.3 10.4418 17.3 10C17.3 9.55818 16.9418 9.20001 16.5 9.20001ZM14.5 10C14.5 8.89544 15.3954 8.00001 16.5 8.00001C17.6046 8.00001 18.5 8.89544 18.5 10C18.5 11.1046 17.6046 12 16.5 12C15.3954 12 14.5 11.1046 14.5 10ZM2.50002 10C2.50002 9.55818 2.85819 9.20001 3.30002 9.20001C3.74185 9.20001 4.10002 9.55818 4.10002 10C4.10002 10.4418 3.74185 10.8 3.30002 10.8C2.85819 10.8 2.50002 10.4418 2.50002 10ZM3.30002 8.00001C2.19545 8.00001 1.30002 8.89544 1.30002 10C1.30002 11.1046 2.19545 12 3.30002 12C4.40459 12 5.30002 11.1046 5.30002 10C5.30002 8.89544 4.40459 8.00001 3.30002 8.00001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.836988fbbc22c6638b990a628f92c6be.svg";
export { ForwardRef as ReactComponent };